// Maps a failed save to the copy deck. Never shows the API's own string: it can carry ids.
export const credentialSaveErrorMessage = error => {
  switch (error === null || error === void 0 ? void 0 : error.status) {
    case 403:
      return (error === null || error === void 0 ? void 0 : error.errorCode) === 'AccessDenied' ? "This login also serves properties you don't have access to, so only someone with access to all of them can change it." : "Your plan doesn't include Bill Automation, so a new login can't be added. Existing logins can still be updated.";
    case 404:
      return 'This login no longer exists. Reload the page to see the current one.';
    case 400:
      return "These details don't match this utility. Reload the page and try again.";
    case 503:
      return 'Saving logins is unavailable right now. Try again in a few minutes.';
    default:
      return "The login couldn't be saved, so nothing changed. Try again.";
  }
};